module.exports = __webpack_public_path__ + "media/application/images/2023/stills_1.1.8-6c643aa6a8e8bf6a9f6c26134079dc66.png";